/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Theme_LightInputs */

const en_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light Mode`)
};

const pt_br2_profile_theme_light = /** @type {(inputs: Profile_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo Claro`)
};

/**
* | output |
* | --- |
* | "Light Mode" |
*
* @param {Profile_Theme_LightInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_theme_light = /** @type {((inputs?: Profile_Theme_LightInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Theme_LightInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_theme_light(inputs)
	return pt_br2_profile_theme_light(inputs)
});